import { Button } from 'antd';
import styled from 'styled-components';

export const ImageContainer = styled.div<{ loading?: string }>`
  position: relative;
  padding-bottom: 10px;
  display: flex;
  justify-content: ${({ loading }) =>
    loading === 'true' ? 'center' : 'flex-start'};
  gap: 10px;
`;

export const StyledCloseIconV = styled.img`
  position: relative;
  top: 10px;
  right: -83%;
  transform: translateX(-1%);
  cursor: pointer;
`;

export const StyledWarning = styled.div`
  font-family: Inter;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  color: #e14a4a;
  margin-bottom: 16px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const StyledInvite = styled.div`
  width: 100%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #202020;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
    font-size: 16px;
  }
`;

export const StyledText = styled.div`
  margin: 16px 0 0 0;
  width: 100%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 17px;
  color: #000000;
  @media (max-width: 768px) {
    width: 100%;
    font-size: 16px;
  }
`;

export const AvailabilityButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    display: flex;
    justify-content: center;
  }
`;

export const StyledButtonAvailCheck = styled.button`
  width: 140px;
  height: 35px;
  border-radius: 4px;
  border: 1px solid;
  gap: 8px;
  white-space: nowrap;
  border-color: #d8d8d8;
  background: #fdfdfd;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: 0em;
  cursor: pointer;
  @media (max-width: 576px) {
    font-size: 16px;
    width: 341px;
    height: 43px;
    text-align: center;
  }
`;

export const StyledButtonUnavailable = styled.button`
  width: 140px;
  height: 35px;
  border-radius: 4px;
  border: 1px solid;
  gap: 8px;
  cursor: pointer;
  white-space: nowrap;
  border-color: #d8d8d8;
  background: #fdfdfd;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: 0em;
  @media (max-width: 576px) {
    font-size: 16px;
    font-weight: 600;
    width: 341px;
    height: 43px;
    text-align: center;
  }
`;

export const Styledtext = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  word-wrap: break-word;
  color: '#000000';
  @media (max-width: 576px) {
    width: 100%;
    font-size: 16px;
  }
`;

export const StyledUploadButton = styled(Button)`
  width: 472px;
  height: 124px;
  border: 1px dashed #bababa;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const UnavailableButton = styled(Button)`
  font-size: 12px;
  font-weight: 600;
`;

export const AvailableButton = styled(Button)`
  font-size: 12px;
  font-weight: 600;
`;

export const UnavailableMobileButton = styled.div`
  font-size: 14px;
  font-weight: 600;
  display: 'flex';
  justify-content: 'center';
  width: '100%';
  height: '44px';
  border: 'none';
`;

export const AvailableMobileButton = styled.div`
  font-size: 14px;
  width: '100%';
  height: '44px';
  border: 'none';
`;

export const WardrobeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const WardrobeItemContainer = styled.div<{ i: number }>`
  width: 50%;
  padding-left: ${(props) => (props.i % 2 == 0 ? 0 : '8px')};
  padding-right: ${(props) => (props.i % 2 == 1 ? 0 : '8px')};
`;
export const MeasurementStyledText = styled.div`
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  color: ${(props) => props.theme.palette.greyscale[5]};
  margin-top: 24px;
  margin-bottom: 12px;
`;
